import React from "react";

import ClearIcon from "@mui/icons-material/Clear";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, InputAdornment, Stack, TextField, TextFieldProps } from "@mui/material";

type Props = {
  isShow: boolean;
  onIsShow: (value: boolean) => void;
  onClear?: () => void;
} & Omit<TextFieldProps, "select" | "fullWidth" | "sx">;

export const SelectField: React.FC<Props> = ({ isShow, onIsShow, onClear, ...props }) => {
  const { disabled } = props;
  return (
    <Stack direction="row" alignItems="center" gap="10px">
      <TextField
        sx={{ input: { padding: "12.5px 14px" } }}
        select
        fullWidth
        {...props}
        InputProps={{
          endAdornment: onClear ? (
            <InputAdornment position="end" sx={{ marginRight: "25px" }}>
              <IconButton disabled={disabled} onClick={() => onClear()} edge="end">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : null
        }}
      />
      <IconButton disabled={disabled} onClick={() => onIsShow(!isShow)}>
        {isShow ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon sx={{ color: "#92A7BC" }} />}
      </IconButton>
    </Stack>
  );
};
